import React from 'react';

/** Page title + subtitle shown inside the page body (not the top navbar). */
export default function PageHeader({ title, subtitle, eyebrow }) {
  return (
    <header className="page-header">
      {eyebrow ? <div className="eyebrow">{eyebrow}</div> : null}
      <h1 className="page-header__title">{title}</h1>
      {subtitle ? <p className="page-header__sub">{subtitle}</p> : null}
    </header>
  );
}
